import angular from "angular";

angular
    .module('usersControl.user', [])
    .service('User', ['$http', function ($http) {

        function uri(id, path) {
            let link = '/control-panel/users';
            if (id) {
                link += '/' + id;
            }
            if (path) {
                link += '/' + path;
            }
            return link;
        }

        this.getList = function (params) {
            return $http.get(uri(null, 'get-list'), {params: params});
        };

        this.store = function (params) {
            return $http.post(uri(), params);
        };

        this.update = function (id, params) {
            params['_method'] = 'PUT';
            return $http.post(uri(id), params);
        };

        this.toggleRole = function (userId, roleId) {
            return $http.post(uri(userId, 'toggle-role'), {roleId: roleId});
        };

        this.togglePermission = function (userId, permissionId) {
            return $http.post(uri(userId, 'toggle-permission'), {permissionId: permissionId});
        };

    }]);

export default 'usersControl.user';


// WEBPACK FOOTER //
// ./resources/assets/modules/users-control/user.js